module.exports = __webpack_public_path__ + "static/media/luis.53e4dde4.jpg";